import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=2bf8d632"
import script from "./preloader.vue?vue&type=script&lang=js"
export * from "./preloader.vue?vue&type=script&lang=js"
import style0 from "./preloader.vue?vue&type=style&index=0&id=2bf8d632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports